import React, { Fragment, useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import { validatePaymentAuthCode } from "../services/api/authorizations";
import { getRedirectionData } from "../services/api/entities";
import { setSessionRedirectionData } from "../utils/handleRedirectionData";
import { setRedirectionData as setRedirectionDataAPI } from "../services/api/entities";
import { showToast } from "../utils/helper";
import { useQuery } from "../utils/hooks/useQuery";

export const RedirectionPayments = () => {
  const [redirectTo, setRedirectTo] = useState(false);
  let query = useQuery();

  useEffect(() => {
    // http://localhost:8080/#/Detalles/Confirmacion?auth_code=authCodeResultante987&pre_transaction_id=1234
    const auth_code = query.get("auth_code");
    const pre_transaction_id = query.get("pre_transaction_id");

    getRedirectionData({ redirectionId: pre_transaction_id })
      .then(({ response: redirectionResponse }) => {
        if (redirectionResponse.found) {
          const redirectData = redirectionResponse.redirectionData;

          validatePaymentAuthCode({ auth_code })
            .then(({ response }) => {
              if (!response.valid_payment) {
                showToast("Código de autorización inválido.");
                setRedirectTo({
                  url: "/",
                  data: {},
                });
              } else {
                setRedirectionDataAPI({});

                if (redirectData.id === pre_transaction_id) {
                  switch (redirectData.data.type) {
                    case "Offer":
                      setRedirectTo({
                        url: "/invest",
                        data: redirectData.data.payload,
                      });
                      break;
                    default:
                      showToast("Tipo de autorización incorrecto.");
                      setRedirectTo({
                        url: "/",
                        data: {},
                      });
                  }
                } else {
                  showToast("Código de redirección inválido.");
                  setRedirectTo("/");
                }
              }
            })
            .catch((err) => {
              console.error(err);
              showToast("Error validando código de autorización.");
              setRedirectTo("/");
            })
            .finally(() => {
              setSessionRedirectionData(false);
            });
        } else {
          showToast("Error obteniendo información de redirección", true);
          setRedirectTo({
            url: "/",
            data: {},
          });
        }
      })
      .catch((err) => {
        console.error(err);
        showToast("Error obteniendo información de redirección", true);
      });
  }, []);

  if (redirectTo) {
    return (
      <Redirect
        to={{
          pathname: redirectTo.url,
          state: { redirectionData: redirectTo.data },
        }}
      />
    );
  }

  return (
    <Fragment>
      <Row>
        <Col>
          <h1>Redireccionando...</h1>
        </Col>
      </Row>
    </Fragment>
  );
};
